<template>
  <div class="pa-4 pa-md-5">
    <!-- Botón Volver -->
    <v-btn @click="$router.back()" class="back-btn mb-3">
      <v-icon left>mdi-arrow-left</v-icon>
      VOLVER
    </v-btn>

    <!-- Contenedor Principal de la Tabla -->
    <v-col cols="12" class="pa-0">
      <tabla
        Titulo="Gestión de Usuarios por Cliente"
        :Cabecera="Cabecera"
        :Items="Usuarios"
        :Excel="true"
        :Crear="true"
        :Loading="LoadingUserClients"
      />
    </v-col>
  </div>
</template>

<script>
import tabla from "@/components/cliente/tablausuarios.vue";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    tabla
  },
  data() {
    return {
      Cabecera: [
        {
          text: "ID",
          value: "id",
          align: "center",
          width: 90
        },
        {
          text: "Cliente / Empresa",
          value: "razon_social",
          align: "left"
        },
        {
          text: "Miembros Asignados",
          value: "miembros",
          align: "center",
          width: 220
        },
        {
          text: "Acciones",
          value: "accion",
          align: "center",
          sortable: false,
          width: 170
        }
      ]
    };
  },
  computed: {
    ...mapState("cliente", ["Usuarios", "LoadingUserClients"])
  },
  methods: {
    ...mapActions("cliente", ["obtenerUsuariosPorClientes"])
  },
  created() {
    this.obtenerUsuariosPorClientes();
  }
};
</script>
